import React from "react";
import { useSelector } from "react-redux";
import { getTheme } from "@icarius-pages/login/selectors";
import WarningIcon from "@material-ui/icons/Warning";
import InfoIcon from "@material-ui/icons/Info";
import ErrorIcon from "@material-ui/icons/Error";

const getWarningText = (warning) => typeof warning === "string" ? warning : JSON.stringify(warning);

const GenerationDataPanel = ({ summary, warnings, summaryIsError }) => {

  const theme = useSelector(getTheme);
  const lightModeIsOn = theme.theme === "light";
  const hasWarnings = warnings && warnings.length > 0;
  const hasSummary = Boolean(summary && String(summary).trim());
  const showSummaryError = hasSummary && Boolean(summaryIsError);

  if (!hasSummary && !hasWarnings) return null;

  const getBackgroundColor = () => {
    if (showSummaryError) return lightModeIsOn ? "#FF7A70" : "#84221F ";
    if (hasWarnings) return lightModeIsOn ? "#FEF7C8" : "#332E1B";
    return lightModeIsOn ? "#E9F2FE" : "#1C2B42";
  };

  return (
    <div
      data-testid={"generation-data-panel"}
      style={{
        backgroundColor: getBackgroundColor(),
        borderRadius: 6,
        padding: "8px 12px",
        margin: "0px 10px 10px",
      }}>
      {hasSummary && (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {showSummaryError
            ? <ErrorIcon style={{ color: lightModeIsOn ? "#c21515" : "#ef9a9a", fontSize: 20 }} />
            : <InfoIcon style={{ color: lightModeIsOn ? "#1E88E5" : "#90CAF9", fontSize: 20 }} />}
          <div style={{ flex: 1 }}>
            <div style={{ marginTop: 2 }}>{summary}</div>
          </div>
        </div>
      )}
      {hasWarnings && (
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: hasSummary ? 10 : 0 }}>
          <WarningIcon style={{ color: lightModeIsOn ? "#F9A825" : "#FFC107", fontSize: 20 }} />
          <div style={{ flex: 1 }}>
            <ul style={{ margin: "4px 0px 0px", paddingLeft: 0 }}>
              {warnings.map((warning, index) => (
                <li key={index} style={{ listStyleType: "none" }}>{getWarningText(warning)}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  )
}

export default GenerationDataPanel;
